import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';
import { VirtualStoreRoutingModule } from './virtual-store-routing.module';
import { ShoppingCartComponent } from 'src/app/components/virtual-store/shopping-cart/shopping-cart.component';
import { ProductListComponent } from 'src/app/components/virtual-store/product-list/product-list.component';
import { ProductComponent } from 'src/app/components/virtual-store/product/product.component';
import { ProductDetailComponent } from 'src/app/components/virtual-store/product-detail/product-detail.component';
import { VirtualStoreContainerComponent } from 'src/app/components/virtual-store/virtual-store-container/virtual-store-container.component';
import { VirtualStoreDniValidatorComponent } from 'src/app/components/virtual-store/virtual-store-dni-validator/virtual-store-dni-validator.component';
import { VirtualStoreHeaderComponent } from 'src/app/components/virtual-store/virtual-store-header/virtual-store-header.component';
import { VirtualStoreFooterComponent } from 'src/app/components/virtual-store/virtual-store-footer/virtual-store-footer.component';
import { DniValidationDigitComponent } from 'src/app/components/virtual-store/dni-validation-digit/dni-validation-digit.component';
import { OrderValidationComponent } from 'src/app/components/virtual-store/order-validation/order-validation.component';
import { OrderConfirmationComponent } from 'src/app/components/virtual-store/order-confirmation/order-confirmation.component';
import { PersonalDataValidationComponent } from 'src/app/components/virtual-store/personal-data-validation/personal-data-validation.component';
import { OrderInsertResponseComponent } from 'src/app/components/virtual-store/order-insert-response/order-insert-response.component';
import { OrderListComponent } from 'src/app/components/virtual-store/order-list/order-list.component';
import { OrderDetailComponent } from 'src/app/components/virtual-store/order-detail/order-detail.component';
import { LoginComponent } from 'src/app/components/login/login.component';
import { PopoverModule } from "ngx-popover";
import { PopupServiceComponent } from 'src/app/components/modals/popup-service/popup-service.component';
import { PopupCartComponent } from 'src/app/components/modals/popup-cart/popup-cart.component';
import { PopupServiceListComponent } from 'src/app/components/modals/popup-service-list/popup-service-list.component';
import { FinancingDeliveryComponent } from 'src/app/components/virtual-store/financing-delivery/financing-delivery.component';

@NgModule({
  declarations: [
    ShoppingCartComponent,
    ProductComponent,
    ProductListComponent,
    VirtualStoreContainerComponent,
    ProductDetailComponent,
    VirtualStoreDniValidatorComponent,
    VirtualStoreHeaderComponent,
    VirtualStoreFooterComponent,
    DniValidationDigitComponent,
    OrderValidationComponent,
    OrderConfirmationComponent,
    PersonalDataValidationComponent,
    OrderInsertResponseComponent,
    OrderListComponent,
    OrderDetailComponent,
    LoginComponent,
    FinancingDeliveryComponent
  ],
  imports: [
    CommonModule,
    VirtualStoreRoutingModule,
    SharedModule,
    PopoverModule
  ],
  entryComponents: [
    VirtualStoreDniValidatorComponent,
    DniValidationDigitComponent,
    OrderInsertResponseComponent,
    OrderDetailComponent,
    LoginComponent,
    PopupServiceComponent,
    PopupCartComponent,
    PopupServiceListComponent
  ]
})
export class VirtualStoreModule { }
